<script>
  export default {
    name: 'Hair',
    functional: true,
    render(createElement) {
      return createElement('span', { class: 'hair' }, '\xa0')
    }
  }
</script>

<style>
  .hair {
    letter-spacing: -0.1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Hair.vue?4e1fbcba